import React from 'react';

interface JobRequirementsSectionProps {
  requirements: string[];
  onRequirementChange: (index: number, value: string) => void;
  onAddRequirement: () => void;
  onRemoveRequirement: (index: number) => void;
}

const JobRequirementsSection: React.FC<JobRequirementsSectionProps> = ({
  requirements,
  onRequirementChange,
  onAddRequirement,
  onRemoveRequirement
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Requirements
      </label>
      <div className="space-y-2">
        {requirements.map((requirement, index) => (
          <div key={index} className="flex items-center space-x-2">
            <input
              type="text"
              value={requirement}
              onChange={(e) => onRequirementChange(index, e.target.value)}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter job requirement"
            />
            {requirements.length > 1 && (
              <button
                type="button"
                onClick={() => onRemoveRequirement(index)}
                className="text-red-500 hover:text-red-700"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            )}
          </div>
        ))}
        <button
          type="button"
          onClick={onAddRequirement}
          className="flex items-center space-x-2 text-blue-600 hover:text-blue-800"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          <span>Add Requirement</span>
        </button>
      </div>
    </div>
  );
};

export default JobRequirementsSection;
